/** JOBS.JS **/

/* Initialize */
var jobElements = document.querySelectorAll('#sectionJobs .job');


/* Listeners */
jobElements.forEach((jobEl)=>{
    jobEl.addEventListener('click', (e)=>{
        var job_info = jobEl.nextElementSibling;

        $(job_info).slideToggle('fast');
    })
})


